// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bubble-color {
  width: 15px;
  height: 15px;
  display: inline-block;
  border-radius: 30px;
  margin-right: 15px;
}

.titleadd {
  color: white;
  margin-left: 320px;
}

.first-bloc {
  margin-top: 25px;
}

.bloc-actions {
  margin-top: 25px;
}
.bloc-actions .action-button {
  margin-right: 15%;
}

.error {
  color: #f44336;
  margin-top: 15px;
}

.div-toggle {
  margin-bottom: 15px;
}

.select-user {
  margin-bottom: 20px;
}

.selected-name {
  font-weight: 700;
  margin-left: 15px;
  margin-right: 15px;
}

.toggle {
  margin-left: 10px;
}

.choose-date {
  margin-top: 15px;
}

.red {
  color: red;
}

mat-horizontal-stepper {
  width: 100%;
  height: 100%;
}

.notary-text {
  padding-right: 15px;
  color: #000;
}

::ng-deep .mat-mdc-select-arrow {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/app/+home/+calendar/see-calendar/shared/components/dialog-add-resa/dialog-add-resa.component.scss"],"names":[],"mappings":"AACA;EACE,WAAA;EACA,YAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;AAAF;;AAEA;EACE,YAAA;EACA,kBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,gBAAA;AACF;AACE;EACE,iBAAA;AACJ;;AAGA;EACE,cAAA;EACA,gBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,gBAAA;EACA,iBAAA;EACA,kBAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,gBAAA;AAAF;;AAGA;EACE,UAAA;AAAF;;AAGA;EACE,WAAA;EACA,YAAA;AAAF;;AAGA;EACE,mBAAA;EACA,WAAA;AAAF;;AAGA;EACE,aAAA;AAAF","sourcesContent":["\r\n.bubble-color {\r\n  width: 15px;\r\n  height: 15px;\r\n  display: inline-block;\r\n  border-radius: 30px;\r\n  margin-right: 15px;\r\n}\r\n.titleadd{\r\n  color: white;\r\n  margin-left: 320px;\r\n\r\n}\r\n.first-bloc {\r\n  margin-top: 25px;\r\n}\r\n\r\n.bloc-actions {\r\n  margin-top: 25px;\r\n\r\n  .action-button {\r\n    margin-right: 15%;\r\n  }\r\n}\r\n\r\n.error {\r\n  color: #f44336;\r\n  margin-top: 15px;\r\n}\r\n\r\n.div-toggle {\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.select-user {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.selected-name {\r\n  font-weight: 700;\r\n  margin-left: 15px;\r\n  margin-right: 15px;\r\n}\r\n\r\n.toggle {\r\n  margin-left: 10px;\r\n}\r\n\r\n.choose-date {\r\n  margin-top: 15px;\r\n}\r\n\r\n.red {\r\n  color: red;\r\n}\r\n\r\nmat-horizontal-stepper {\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n.notary-text {\r\n  padding-right: 15px;\r\n  color: #000;\r\n}\r\n\r\n::ng-deep .mat-mdc-select-arrow {\r\n  display: none;\r\n}\r\n\r\n\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
